import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-fit flex-nowrap items-end gap-[8px] lg:gap-[12px]',
    price:
      'text-[14px] leading-[140%] font-semibold text-white lg:text-2xl lg:leading-[120%] lg:font-medium',
    loyalty:
      'lg:text-l text-bg-system-gray-500 trading-[-0.05%] text-[12px] leading-[120%]'
  },
  variants: {}
});
